import { TechnicalDataForConfiguration, TechnicalDataForModel } from '~/graphql/__generated__/graphql';

export const technicalDataPresent = (
	technicalData: TechnicalDataForConfiguration | TechnicalDataForModel | undefined | null,
): boolean => {
	if (technicalData && technicalData?.items?.length > 0) {
		return true;
	}
	return false;
};
